import { tsUtils } from '@neo-one/ts-utils';
import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class VariableDeclarationListCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.VariableDeclarationList;
    }
    visitNode(sb, node, options) {
        tsUtils.variable.getDeclarations(node).forEach((decl) => {
            sb.visit(decl, options);
        });
    }
}

//# sourceMappingURL=VariableDeclarationListCompiler.js.map
